import * as types from './constants';

const initialState = {
  data: {},
  loading: false,
  errors_api: {}
};

const actions = {
  // Add Lookbook Users
  [types.ADD_LOOKBOOK_USERS_REQUEST]: state => {
    const data = {
      ...state,
      loading: true
    };

    return { ...data };
  },

  [types.ADD_LOOKBOOK_USERS_DONE]: (state, { payload }) => {
    const data = {
      ...state,
      loading: false,
      data: payload,
      errors_api: {}
    };

    return { ...data };
  },

  [types.ADD_LOOKBOOK_USERS_FAILED]: (state, { payload }) => {
    const data = {
      ...state,
      loading: false,
      errors_api: payload
    };

    return { ...data };
  },

  [types.ADD_LOOKBOOK_USERS_CLEAR_ERRORS]: (state, { payload }) => {
    let errors_api = { ...state.errors_api };
    let newState = { ...state };
    if (payload) {
      delete errors_api[payload];
    } else {
      errors_api = {};
    }

    return { ...newState, errors_api };
  },

  [types.ADD_LOOKBOOK_USERS_RESET]: () => {
    const data = {
      ...initialState
    };

    return { ...data };
  }
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};

